module.exports = __webpack_public_path__ + "img/alousus.a7d9388b.png";